<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!eliminazioneInCorso"
  [dismissableMask]="!eliminazioneInCorso"
  [style]="{width: '450px', maxWidth: '95vw'}"
  styleClass="p-fluid conferma-eliminazione-dialog"
  [showHeader]="false"
  (onHide)="onHide()">

  <div class="dialog-container">
    <!-- Header del dialog -->
    <div class="dialog-header">
      <div class="header-content">
        <span class="material-icons" style="font-size: 28px; margin-right: 8px;">delete</span>
        <h2>Conferma Eliminazione</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="eliminazioneInCorso"
        (click)="onHide()">
      </button>
    </div>

    <!-- Contenuto principale -->
    <div class="dialog-content" *ngIf="richiesta">
      <span class="material-icons warning-icon">warning</span>

      <h3>Sei sicuro di voler eliminare questa richiesta?</h3>

      <p>Questa operazione è irreversibile. La richiesta verrà eliminata definitivamente dal sistema.</p>

      <div class="richiesta-info">
        <p-divider></p-divider>
        <div class="info-row">
          <div class="info-label">Ente:</div>
          <div class="info-value">
            <span class="material-symbols-outlined"
              [style.color]="stiliService.getColoreIconaEnteEsecutore(richiesta.enteEsecutore)"
              style="vertical-align: middle; margin-right: 8px;">
              {{ stiliService.getMaterialIconEnteEsecutore(richiesta.enteEsecutore) }}
            </span>
            {{ richiesta.enteEsecutore.label }}
          </div>
        </div>

        <div class="info-row">
          <div class="info-label">Anno:</div>
          <div class="info-value">{{ richiesta.anno }}</div>
        </div>

        <div class="info-row">
          <div class="info-label">Stato:</div>
          <div class="info-value">
            <span class="material-symbols-outlined"
              [style.color]="stiliService.getColoreIconaStatoRichiesta(richiesta)"
              style="vertical-align: middle; margin-right: 8px;">
              {{ stiliService.getMaterialIconStatoRichiesta(richiesta) }}
            </span>
            {{ richiesta.stato.descrizione }}
          </div>
        </div>

        <div class="info-row" *ngIf="richiesta.importoRichiesto">
          <div class="info-label">Importo richiesto:</div>
          <div class="info-value importo">{{ richiesta.importoRichiesto | currency:'EUR':'symbol':'1.2-2':'it-IT' }}</div>
        </div>
      </div>
    </div>

    <!-- Footer del dialog -->
    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        [disabled]="eliminazioneInCorso"
        (click)="annulla()">
      </button>
      <button
        pButton
        pRipple
        label="Elimina"
        icon="pi pi-trash"
        class="p-button-danger"
        [loading]="eliminazioneInCorso"
        (click)="confermaEliminazione()">
      </button>
    </div>
  </div>
</p-dialog>

<!-- Toast per messaggi -->
<p-toast position="top-right"></p-toast>
